<div id="container-wizard" class="modal-body">
    <button
        #closeModal
        type="button"
        class="close"
        aria-label="Close"
        (click)="modalService.dismissAll()"
    >
        <span class="material-icons-outlined">close</span>
    </button>
    <div class="head-title text-center">
        <div class="point-container">
            <p class="dot blue mb-0"></p>
            <p class="dot pink mb-0"></p>
            <p class="dot violet mb-0"></p>
        </div>
        <div class="head-title-text mb-0">
            {{ headlineTranslationKey | translate }}
        </div>
    </div>
    <div class="slider-points text-center d-flex justify-content-center">
            <span
                (click)="onBackButton()"
                *ngIf="wizardIndexActive !== 1"
                class="back-btn"
            ><mat-icon
                class="d-flex justify-content-center align-items-center arrow-back-icon"
            >arrow_back</mat-icon
            ></span
            >
        <div
            class="slide-point-container"
            *ngFor="let wizardPointImage of wizardPointImages"
        >
            <img
                [src]="wizardPointImage"
                alt="wizardPointImage"
                class="slide-point"
            />
        </div>
        <span
            *ngIf="wizardIndexActive !== 1"
            class="back-btn back-btn-placeholder"
            aria-hidden="true"
        ><mat-icon
            class="d-flex justify-content-center align-items-center arrow-back-icon"
        >arrow_back</mat-icon
        ></span
        >
    </div>
    <div class="slide-wrapper">
        <app-wizard-slide
            #childComponent
            [wizardList]="wizardDataList"
            (activeWizardPosition)="changeWizardPosition($event)"
            (addProject)="addProjectSuccessfully($event)"
            [type]="type"
        ></app-wizard-slide>
    </div>
</div>
